import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    // eslint-disable-next-line max-params
    createFetchParams: (selectedMonth, pagination, search, sort, exclude, entities) => ({
        ...pagination,
        ...search,
        ...entities,
        ordering:       sort,
        exclude,
        selected_month: Math.floor(selectedMonth / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'cloudBillingServices',
        endpoint:           endpoints.cloudBilling.servicesEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => ({
            ...item,
            total:         item.total_selected_month,
            totalPrevious: item.total_previous_month,
            count:         item.count,
            results:       item.results.map(service => ({
                id:                    service.id,
                name:                  service.name,
                spending:              service.spending_selected_month,
                previousSpending:      service.spending_previous_month,
                spendingSelectedMonth: service.spending_selected_month,
                spendingPreviousMonth: service.spending_previous_month,
                vendor:                {
                    code: service.vendor.code,
                    name: service.vendor.title
                }
            }))
        })

    })
};




// WEBPACK FOOTER //
// ./src/modules/store/cloudBillingServices.js